import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAgent: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAgent"><Circle cx="12" cy="6" r="3" stroke="currentColor"/><Circle cx="6.5" cy="18" r="3" stroke="currentColor"/><Circle cx="17.5" cy="18" r="3" stroke="currentColor"/><Path d="M12 9V12M12 12H6.5V15M12 12H17.5V15" stroke="currentColor"/></CentralIconBase>;
});

export default IconAgent;
